'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const PageTracking = dynamic(() => import('@components/page-tracking'), {
  ssr: false,
});

export function PageTrackingBootstrap() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      const callbackId = window.requestIdleCallback(() => setIsReady(true), {
        timeout: 3000,
      });
      return () => window.cancelIdleCallback(callbackId);
    }

    const timeoutId = window.setTimeout(() => setIsReady(true), 1);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return isReady ? <PageTracking /> : null;
}
